// extracted by mini-css-extract-plugin
module.exports = {"menuLinks":"_UV6QJTV","link":"_2t0LRM_"};